import { AxiosResponse } from 'axios';

import { CreateUserInspectionRequestType } from './index';

import { CommonResponseType } from 'api/authApi';
import { authServiceClient } from 'config';
import { UserInspectionType } from 'state';

export const fetchUserInspectionRequest = (inspectionId: string) => {
  return authServiceClient.get<
    UserInspectionType,
    AxiosResponse<UserInspectionType>,
    string
  >(`/user-inspection/${inspectionId}`);
};

export const editUserInspectionRequest = (
  userInspection: CreateUserInspectionRequestType,
) => {
  return authServiceClient.put<
    CommonResponseType,
    AxiosResponse<UserInspectionType>,
    CreateUserInspectionRequestType
  >(`/user-inspection/${userInspection.inspectionId}`, userInspection);
};
